
import { LanguageSelector } from "./LanguageSelector";
import type { Database } from "@/integrations/supabase/types";

type SupportedLanguage = Database["public"]["Enums"]["supported_language"];
type Survey = Database["public"]["Tables"]["surveys"]["Row"];

interface SurveyHeaderProps {
  survey: Survey;
  language: SupportedLanguage;
  onLanguageChange: (language: SupportedLanguage) => void;
}

export const SurveyHeader = ({ survey, language, onLanguageChange }: SurveyHeaderProps) => {
  return (
    <div className="space-y-4">
      <div className="mb-2">
        <LanguageSelector
          selectedLanguage={language}
          onLanguageChange={onLanguageChange}
        />
      </div>
      <div className="text-center">
        <h1 className="text-2xl font-semibold tracking-tight">
          {survey.title?.[language] || "Undersökning"}
        </h1>
      </div>
    </div>
  );
};
